import { Component } from 'engine/ecs';

export class Follow extends Component {}
